import { FunctionComponent, useContext, useEffect } from "react";
import { Notification, NotificationProps } from "@animech/ui";
import { ApiDataContext, ApiNotification } from "src/api";
import { useUiData } from "src/ui/data";
import { Term } from "@definitions";

const errorTitleTerm: Term = "request:error-title";
const errorMessageTerms: Partial<Record<ApiNotification["requestType"], Term>> =
	{
		save: "request:save-failed",
		email: "request:email-failed",
		pdf: "request:pdf-failed",
	};

export const ApiNotifications: FunctionComponent = () => {
	const { notifications, localizer } = useUiData();
	const { apiNotification } = useContext(ApiDataContext);

	useEffect(() => {
		if (!apiNotification) {
			return;
		}

		const { status, requestType } = apiNotification;
		const messageTerm = errorMessageTerms[requestType];
		const notification =
			status === "error" ? (
				<ErrorNotification
					apiNotification={
						messageTerm
							? {
									...apiNotification,
									name: localizer.localizeTerm(errorTitleTerm),
									message: localizer.localizeTerm(messageTerm),
								}
							: apiNotification
					}
				/>
			) : (
				<SuccessNotification apiNotification={apiNotification} />
			);

		notifications.show(notification);
	}, [apiNotification, localizer, notifications]);

	return null;
};

type CustomNotificationProps = NotificationProps & {
	apiNotification: ApiNotification;
};
const SuccessNotification = (props: CustomNotificationProps) => {
	const { apiNotification } = props;
	const { name, message } = apiNotification;
	return (
		<Notification
			icon="checkbox"
			timeout={3000}
			color="success"
			title={name}
			{...props}
		>
			{message}
		</Notification>
	);
};

const ErrorNotification = (props: CustomNotificationProps) => {
	const { apiNotification } = props;
	const { name, message } = apiNotification;
	return (
		<Notification
			icon="error"
			color="alert"
			timeout={8000}
			title={name}
			{...props}
		>
			{message}
		</Notification>
	);
};
